import { deleteCookie } from "@/utils/cookies";
import { buildDpaUrl } from "@/utils/dpa";
import { GA4 } from "@/utils/ga4Utils";

import { QuizResurfaceProduct } from "./quizResurfaceProduct";

const CATEGORY_MAP: Record<string, string> = {
  wom: "Women",
  bal: "Balance",
  pos: "Postpartum",
  men: "Men",
  msr: "MenPlus",
};

const GENDER_MAP: Record<string, "Men" | "Women"> = {
  men: "Men",
  msr: "Men",
};

export const addQuizResurfaceToCart = (
  product: QuizResurfaceProduct,
  displayPrice: number | undefined,
  promoLive: boolean,
  sku = `${product.sku}-S01`
) => {
  const firstChars = sku?.slice(0, 3)?.toLowerCase() ?? "";
  const boosterChars = sku?.split("-")?.[0].slice(3, -1)?.toLowerCase();
  const boostersCount = Math.floor((boosterChars?.length ?? 0) / 2);
  const isOneTime = sku?.includes("-N01");
  const purchaseSource = product.purchaseSource
    ? `${product.purchaseSource}_quiz_banner`
    : "quiz_banner";

  GA4.onProductAdded({
    purchase_source: purchaseSource,
    text: isOneTime ? "Buy Once" : "Subscribe",
    options: [
      {
        sku,
        name: product.fullname || product.name || "",
        price: displayPrice,
        old_price: product.price ?? null,
        label1: product.imageUrl,
        product_category: "Growthplan",
        product_core_category: CATEGORY_MAP[firstChars] as
          "Women" | "Balance" | "Postpartum" | "Men" | "MenPlus" | undefined,
        product_gender: GENDER_MAP[firstChars] ?? "Women",
        billing_interval: isOneTime ? null : "1 month",
        shipping_interval: isOneTime ? null : "1 month",
        subscription_type: isOneTime ? null : "1 month",
        purchase_type: isOneTime ? "Single Purchase" : `Growthplan ${boostersCount + 1}`,
        quantity: 1,
        quiz_reco: true,
        purchase_source: purchaseSource,
        source: purchaseSource,
        type: "button",
      },
    ],
  });

  deleteCookie("resurface-quiz");
  window.location.href = buildDpaUrl(sku, {
    purchaseSource: purchaseSource,
    useDpaKey: Boolean(promoLive && product.promoUseDpaKey && !isOneTime),
  });
};
